import { SVGProps } from 'react'

const SvgSingleSensorFilledDrop = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12 2a1 1 0 0 0-1 1v1H8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3v5a1 1 0 1 0 2 0v-5a4 4 0 0 1 4-4h1V6a2 2 0 0 0-2-2h-3V3a1 1 0 0 0-1-1zm0 5a2.995 2.995 0 0 1 3 3 3.002 3.002 0 0 1-4 2.83A3.002 3.002 0 0 1 12 7zm6.37 7-2.38 2.342c-.309.31-.551.659-.726 1.053A3.126 3.126 0 0 0 15 18.681c0 .92.328 1.704.984 2.35.657.645 1.452.968 2.385.968.934 0 1.727-.323 2.383-.969a3.173 3.173 0 0 0 .984-2.35c0-.463-.086-.893-.261-1.287a3.49 3.49 0 0 0-.727-1.052L18.37 14z' />
  </svg>
)

export default SvgSingleSensorFilledDrop
